import React, { Component } from "react";
import { Checkbox, Form, Input } from "antd";
import { connect } from 'react-redux'
import style from "./list.module.sass";
// import { Http } from "../../../helpers/axois";
import { pushToast } from '../../../../stateManager/store/toast/actions'
import { Http } from "../../../../helpers/axois";


const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
    }
};

interface State {
    key?: string;
    value?: string;
    required?: boolean;
    protected?: boolean;
    visibleClient?: boolean;
    isPublic?:boolean;
    showError?: boolean;
}

interface Props {
    onSubmit: (submit: (setvisible: (status: boolean) => void) => void) => void;
    appId?: any;
    versionId?: any;
    getConfigs: (res: any) => void;
    editInitialData?: State & { configId?: string };
    editable?: boolean;
    pushToast?: (data: any) => void;
    currentBranch?: any;
}

class AppConfiguration extends Component<Props, State> {
    constructor(props: any) {
        super(props);
        this.state = {
            key:
                this.props.editInitialData && this.props.editInitialData.key
                    ? this.props.editInitialData.key
                    : "",
            value: this.props.editInitialData && this.props.editInitialData.value
                ? this.props.editInitialData.value
                : "",
            required: this.props.editInitialData && this.props.editInitialData.required
                ? this.props.editInitialData.required
                : false,
            protected: this.props.editInitialData && this.props.editInitialData.protected
                ? this.props.editInitialData.protected
                : false,
            visibleClient: this.props.editInitialData && this.props.editInitialData.visibleClient
                ? this.props.editInitialData.visibleClient
                : false,
            isPublic:this.props.editInitialData && this.props.editInitialData.isPublic
            ? this.props.editInitialData.isPublic
            : false,
            showError: false,
        };
        this.props.onSubmit(this.onSubmit);
    }

    onSubmit = (setvisible: (status: boolean) => void) => {
        let { editable, editInitialData } = this.props;
        if (this.state.key) {
            if (this.state.value) {
                if (this.state.value.length <= 1024) {
                    if (!editable) {
                        this.saveService(setvisible);
                    } else {
                        if (editInitialData && editInitialData.configId) {
                            this.updateConfig(editInitialData.configId, setvisible)
                        }
                    }
                } else {
                    this.props.pushToast && this.props.pushToast(
                        { type: 'error', message: 'Value should not exceed 1024 characters' }
                    )
                }
            } else {
                if (!editable) {
                    this.saveService(setvisible);
                } else {
                    if (editInitialData && editInitialData.configId) {
                        this.updateConfig(editInitialData.configId, setvisible)
                    }
                }
            }
            this.setState({ showError: false })
        } else {
            this.setState({ showError: true })
        }
    };

    saveService(setvisible: (status: boolean) => void) {
        const currentBranchId = this.props.currentBranch && this.props.currentBranch[this.props.appId] && this.props.currentBranch[this.props.appId].branchId
        const data = {
            key: this.state.key,
            value: this.state.value,
            required: this.state.required,
            protected: this.state.protected,
            visibleClient: this.state.visibleClient,
            appId: this.props.appId,
            versionId: this.props.versionId,
            branchId: currentBranchId,
            isPublic:this.state.isPublic
        }
        const { getConfigs } = this.props
        Http.post(`app/${this.props.appId}/config`, data).subscribe((res) => {
            this.props.pushToast && this.props.pushToast(
                { type: 'success', message: 'Config saved successfully' }
            )
            getConfigs(res);
            setvisible && setvisible(false)
        }, (err) => {
            this.props.pushToast && this.props.pushToast(
                { type: 'error', message: (err && err.message) ? err.message : 'Config save failed' }
            )
        })

    }

    updateConfig(configId: string, setvisible: (status: boolean) => void) {
        const currentBranchId = this.props.currentBranch && this.props.currentBranch[this.props.appId] && this.props.currentBranch[this.props.appId].branchId
        const data = {
            value: this.state.value,
            required: this.state.required,
            protected: this.state.protected,
            visibleClient: this.state.visibleClient,
            appId: this.props.appId,
            versionId: this.props.versionId,
            branchId: currentBranchId,
            isPublic:this.state.isPublic
        }
        Http.put(`app/${this.props.appId}/config/${configId}`, data).subscribe((res) => {
            this.props.pushToast && this.props.pushToast(
                { type: 'success', message: 'Config updated successfully' }
            )
            this.props.getConfigs(res);
            setvisible && setvisible(false)
        }, (err) => {
            this.props.pushToast && this.props.pushToast(
                { type: 'error', message: (err && err.message) ? err.message : "Config Updataion failed" }
            )
        })
    }

    render() {
        let { editInitialData } = this.props;
        const keyDisable = (editInitialData) ? true : false
        return (
            <div>
                <Form {...formItemLayout} className={style.app + ' override-content'}>
                    <Form.Item
                        required= {true}
                        validateStatus= {this.state.showError && !this.state.key ? "error" : ""}
                        help= {this.state.showError && !this.state.key ? "This field cannot be empty" : ""}
                        label={<span className={style.labelName}>Key</span>}>
                        <Input
                            data-test-id="config_key"
                            disabled={keyDisable}
                            defaultValue={editInitialData && editInitialData.key}
                            value={this.state.key}
                            onChange={(e) => {
                                const re = /^[a-zA-Z0-9_]+$/;
                                if (e.target.value === '' || re.test(e.target.value)) {
                                    this.setState({ key: e.target.value })
                                }
                            }
                            }

                        />
                    </Form.Item>
                    <Form.Item
                        label={<span data-test-id="config_lablename" className={style.labelName}>Value</span>}>
                        <Input
                            data-test-id="config_lablename"
                            defaultValue={editInitialData && editInitialData.value}
                            value={this.state.value}
                            onChange={(e) => {
                                    this.setState({ value: e.target.value })
                                }
                            }
                        />
                    </Form.Item>
                    <br />
                    <Form.Item
                        label={""}
                    >
                        <div className="row" style={{ marginLeft: '-15px', marginRight: '-15px' }}>
                            <div className={"col-md-6 variableCheckbox"}>
                                <Checkbox
                                    data-test-id="config_required"
                                    defaultChecked={editInitialData && editInitialData.required}
                                    checked={this.state.required}
                                    onChange={e => this.setState({ required: e.target.checked })}
                                >Required</Checkbox>
                            </div>
                            <div className={"col-md-6 variableCheckbox"}>
                                <Checkbox
                                    data-test-id="config_protected"
                                    defaultChecked={editInitialData && editInitialData.protected}
                                    checked={this.state.protected}
                                    onChange={e => this.setState({ protected: e.target.checked })}
                                > Protected </Checkbox>
                            </div>
                        </div>
                    </Form.Item>
                    <Form.Item>
                        <div className="row" style={{ marginLeft: '-15px', marginRight: '-15px' }}>
                            <div className={"col-md-6 variableCheckbox"}>
                                <Checkbox
                                    data-test-id="config_visible"
                                    defaultChecked={editInitialData && editInitialData.visibleClient}
                                    checked={this.state.visibleClient}
                                    onChange={e => this.setState({ visibleClient: e.target.checked })}
                                > make it visible for client </Checkbox>
                            </div>
                            <div className={"col-md-6 variableCheckbox"}>
                                <Checkbox
                                    defaultChecked={editInitialData && editInitialData.protected}
                                    checked={this.state.isPublic}
                                    onChange={e => this.setState({ isPublic: e.target.checked })}
                                > Public </Checkbox>
                            </div>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        currentBranch: state.apps.appBranch
    }
}

export default connect(mapStateToProps, { pushToast })(AppConfiguration);
